"use strict";
module.exports = {
  CalendarTab: require("./calendar-tab"),
  MessagesTab: require("./messages-tab"),
  ScheduleTab: require("./schedule-tab"),
};
